module.exports = __webpack_public_path__ + "img/horizontal_3_4_6000.5f6bf9eb.png";